import React, { } from "react";

import { Col, Row } from "react-bootstrap";

import { BottomsheetDropdown } from "components";
import { observer } from "mobx-react";


const WealthPlus = ({ form, data }) => {


  return (
    <div className="">
      <div className="mx-0 my-4">
        {/* <Col md={6} className="col-12"> */}
        {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("policy-term").label}
          </div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey="label"
          bottomsheetTitle={form.$("policy-term").label}
          menuList={form.$("policy-term").extra.optionList}
          value={form.$("policy-term").value}
          onSelect={form.$("policy-term").onChange}
          disabled=""
        />

        {/* </Col> */}
      </div>
      <div className="mx-0 my-4">
        {/* <Col md={6} className="col-12"> */}
        {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
            {form.$("premium-term").label}
          </div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey="label"
          bottomsheetTitle={form.$("premium-term").label}
          menuList={form.$("premium-term").extra.optionList}
          value={form.$("premium-term").value}
          onSelect={form.$("premium-term").onChange}
        />
        {/* </Col> */}
      </div>
    </div>
  );
};

export default observer(WealthPlus);
